// =====================================================
// The Fredline wordmark in what Fredline produces: "Fred" in ink and "line" in the insertion
// blue with a double underline, bold, as on fredline.app (src/components/Wordmark.astro).
// Wherever a produced document shows the name, it shows it this way. (Not where Word shows
// plain text only: the author of the tracked changes, the free version's diagonal watermark.)
// =====================================================

export const WORDMARK_INK = '1A1C2B';
export const WORDMARK_BLUE = '2A5BD7';

/** WordprocessingML runs for the wordmark. `size` in points; `font` names the font. */
export function wordmarkRuns(o: { size?: number; font?: string } = {}): string {
  const font = o.font ? `<w:rFonts w:ascii="${o.font}" w:hAnsi="${o.font}" w:eastAsia="${o.font}" w:cs="${o.font}"/>` : '';
  const sz = o.size ? `<w:sz w:val="${Math.round(o.size * 2)}"/><w:szCs w:val="${Math.round(o.size * 2)}"/>` : '';
  const run = (text: string, color: string, underline: boolean) =>
    `<w:r><w:rPr>${font}<w:b/><w:bCs/><w:i w:val="0"/><w:iCs w:val="0"/><w:caps w:val="0"/><w:strike w:val="0"/><w:color w:val="${color}"/>${sz}` +
    `${underline ? '<w:u w:val="double"/>' : '<w:u w:val="none"/>'}</w:rPr><w:t xml:space="preserve">${text}</w:t></w:r>`;
  return run('Fred', WORDMARK_INK, false) + run('line', WORDMARK_BLUE, true);
}

/** WordprocessingML runs for a text, with each "Fredline" in it as the wordmark. `plain`
 *  makes the runs for the rest of the text (already escaped). */
export function runsWithWordmark(text: string, plain: (escaped: string) => string, o: { size?: number; font?: string } = {}): string {
  const esc = (s: string) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return text.split(/\b(Fredline)\b/).map((part, i) => i % 2 ? wordmarkRuns(o) : part ? plain(esc(part)) : '').join('');
}

/** The wordmark as HTML with its own (inline) styles, for pages without fredline.app's stylesheet. */
export function wordmarkHtml(): string {
  return `<span class="fl-wordmark" style="font-weight:800;color:#1a1c2b;letter-spacing:normal;white-space:nowrap;text-transform:none">Fred` +
    `<span style="color:#2a5bd7;text-decoration:underline double;text-decoration-color:#2a5bd7;text-decoration-thickness:0.07em;text-underline-offset:0.16em;text-decoration-skip-ink:none">line</span></span>`;
}

/** Escape a text for HTML and show each "Fredline" in it as the wordmark. */
export function htmlWithWordmark(text: string): string {
  const esc = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  return esc.replace(/\bFredline\b/g, wordmarkHtml());
}
